class Controller {
  constructor($mdDialog, routeSchedules, manualSchedulesIds) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.selected = {};
    this.manualEstimatesSchedules = routeSchedules;
    this.manualSchedulesIds = manualSchedulesIds;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide(this.selected);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/route/manualEstimatesDialog/manualEstimatesDialog.controller.js